import { Vue, Component, Watch, Ref, Prop } from 'vue-property-decorator';
import { Action, State as StateClass } from 'vuex-class';
import { MetaInfo } from 'vue-meta';
import { ADD_TOAST_MESSAGE as addToastMessage } from 'vuex-toast';
import { ValidationObserver } from 'vee-validate';
import { State } from '@/store/models';
import { titleTemplate } from '@/helpers/meta/title-template';
import FormInput from '@/components/common/form-elements/FormInput.vue';
import * as MUTATIONS from '@/store/constants';
import Loader from '@/components/common/loader/Loader.vue';

@Component({
  components: {
    ValidationObserver,
    FormInput,
    Loader,
  },
})

export default class Reset extends Vue {
  @Prop() isAuthPage!: boolean;

  metaInfo(): MetaInfo {
    return {
      title: titleTemplate(this.$t('meta.reset.title').toString()),
    };
  }

  isLoading: boolean = false;
  email: string = '';

  @Action sendResetPassword!: Function;
  @Action(addToastMessage) addToastMessage!: Function;
  @Action closeModal!: Function;
  @Action openModal!: Function;

  @StateClass operations!: State['operations'];

  @Ref('form') readonly form!: InstanceType<typeof ValidationObserver>;

  mounted(): void {
    if (this.$route.query.email) {
      this.email = this.$route.query.email as string;

      this.$nextTick((): void => {
        this.form.validate();
      });
    }
  }

  @Watch('operations', { deep: true })
  onUserChanged(newAuth: State['operations'], oldAuth: State['operations']): void {
    this.isLoading = true;
    if (newAuth
      && oldAuth
      && oldAuth.name
      && oldAuth.name === MUTATIONS.RESET_PASSWORD_PROCESSING
      && oldAuth.name !== newAuth.name) {
      this.isLoading = false;
      // Notification
      this.addToastMessage({
        text: newAuth.name === MUTATIONS.RESET_PASSWORD_SUCCESS
          ? `${this.$t('auth.reset.emailSent')}. ${this.$t('auth.reset.pleaseCheckInbox')}.`
          : newAuth.error,
        type: newAuth.name === MUTATIONS.RESET_PASSWORD_SUCCESS ? 'success' : 'danger',
      });

      // Reset form to initial state, and prevent
      // showing validation errors ('... is required')
      if (newAuth.name === MUTATIONS.RESET_PASSWORD_SUCCESS) {
        this.email = '';
        this.$nextTick((): void => {
          this.closeModal();
        });
      }
    }
  }
}
